import type { Logger } from "./types";

/**
 * Noop implements the Logger interface and performs no logging.
 */
export class Noop implements Logger {
  constructor(
    readonly instanceId: string,
    readonly params?: Record<string, unknown>,
  ) {}

  error(
    errCode: string,
    caller: string,
    message: string,
    error?: Error | unknown,
    optionalParams?: Record<string, unknown>,
  ): void {
    return;
  }

  kind() {
    return "Noop";
  }

  debug(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    return;
  }

  info(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    return;
  }

  log(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    return;
  }

  trace(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    return;
  }

  warn(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    return;
  }

  cloneWithInstanceId(instanceId: string): Logger {
    return new Noop(instanceId, this.params);
  }

  cloneWithParams(params: Record<string, unknown>, instanceId?: string): Logger {
    return new Noop(instanceId ? instanceId : this.instanceId, Object.assign({}, this.params, params));
  }
}
